import React, { useState } from "react";
import usePrice from "@/framework/product/use-price";
import DynamicButton from "@/components/ui/dynamic-button";
import Counter from "./counter";
import ProductDetailsAccordion from "./product-details-accordion";
import SocialShare from "./social-share";
import WhatsAppButton from "@/components/ui/whatspp-link";
export default function ProductDetails({ product }) {
  const [quantity, setQuantity] = useState(1);
  const { price, basePrice, discount } = usePrice({
    amount: product?.sellingPrice,
    baseAmount: product?.MRP,
    currencyCode: "INR",
  });
  return (
    <div className="h-full w-full flex flex-col items-start justify-start gap-2 py-4 lg:pl-12">
      <h1 className="md:text-[34px] text-[22px] text-brown font-semibold font-glacial">
        {product?.name ?? ""}
      </h1>
      <div
        className={`font-semibold flex items-center text-base text-[#4A5568] flex-wrap gap-x-2 lg:text-xl mt-2`}
      >
        {product?.stock == 0 ? (
          <div className="font-semibold flex text-sm flex-wrap gap-x-2 lg:text-lg bg-red rounded">
            <span className="text-sm md:text-2xl leading-5 font-semibold text-brown">
              Out of stock
            </span>
          </div>
        ) : (
          <div className="flex flex-col">
            <span className="flex text-brown" id="sale-price">
              {price.toLocaleString()}
              {/* {discount && !product?.stock == 0 && ( */}
              <div className="flex gap-4 items-center ml-3 font-medium">
                <del className="text-[#A30A0A]" id="normal-price">
                  {basePrice?.toLocaleString()}
                </del>

                <span className="text-white font-semibold bg-darkBrown rounded-full px-6 py-1 md:py-1.5 leading-none text-xs transform">
                  {discount} Off
                </span>
              </div>
              {/* )} */}
            </span>

            {/* <span className="text-darkBrown text-sm mt-1">
              (Incl. of all taxes)
            </span> */}
          </div>
        )}
      </div>
      <div className="flex items-center gap-x-4 py-4 w-full">
        <Counter
          quantity={quantity}
          onIncrement={() => setQuantity((prev) => prev + 1)}
          onDecrement={() => setQuantity((prev) => (prev !== 1 ? prev - 1 : 1))}
          disableDecrement={quantity === 1 || product?.stock == 0}
          disableIncrement={product?.stock == 0}
        />

        <WhatsAppButton
          phoneNumber="919818314184"
          productLink={`https://www.rosebowl.in/products/${product?.slug}`}
          quantity={quantity}
        />
      </div>

      <ProductDetailsAccordion product={product} />
      <p className="text-sm text-brown mt-4">
        SKU: {product?.sku}-{product?.code}
      </p>
      <SocialShare
        align="horizontal"
        iconColor="text-black"
        url={"https://www.rosebowl.in/products/"}
        slug={product?.slug}
        postTile={product?.name}
        description={product?.description}
      />
    </div>
  );
}
